import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { ITableModel } from '../table/model/tableModel';
import { Helpers } from '../../../helpers';
import { Router } from '@angular/router';
import { appService } from '../../../_services/app.service';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { CommonService } from '../../../_services/common.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-billpayments-transaction',
  templateUrl: './billpayments-transaction.component.html',
  styleUrls: ['./billpayments-transaction.component.scss']
})
export class BillpaymentsTransactionComponent implements OnInit {

  static that: BillpaymentsTransactionComponent;
  tableDetails: ITableModel;
  totalCount: number = 0;
  noOfPages: number = 15;
  searchValue: string = '';
  filterObj: any = {
    Status: 'All'
  };

  payload: any = {};
  @Input() Id: any;
  @Input() referenceType: any;
  @Input() headerName: any;

  @Input() shipmentModetypearray : any = [];
  @Input() parentTypearray : any = [];

  data: any = {};
  reportHeader: any = [];
  TenantId: any;
  CompanyId: any;
  userId: any;

  FromDate: any = {
    formControlName: 'FromDate',
    dataField: 'FromDate',
    placeholder: 'Select FromDate'
  };
  ToDate: any = {
    formControlName: 'ToDate',
    dataField: 'ToDate',
    placeholder: 'Select ToDate'
  };
  searchFieldDetails: any = {
    placeholder: "Search",
    type: "text",
    isSearchBox: true,
  };
  constructor(
    private router: Router,
    private _appService: appService,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private commonService: CommonService,
    private datePipe: DatePipe,
  ) {
    BillpaymentsTransactionComponent.that = this;
  }

  ngOnInit() {
    this.TenantId = JSON.parse(
    this.decryptpipe.transform(JSON.parse(this.cookieService.get("TenantId"))));
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    const storedPerPage = localStorage.getItem('perPage');
    if (storedPerPage) {
      this.noOfPages = parseInt(storedPerPage, 10);
    }
    const currentDate = new Date();
    const firstDateOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);


    this.data[this.ToDate.dataField] = this.datePipe.transform(new Date(), 'dd-MMM-yyyy');
    this.data[this.FromDate.dataField] = this.datePipe.transform(firstDateOfMonth, 'dd-MMM-yyyy');

    this.initalizeForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['Id']) {
      this.Id = changes['Id'].currentValue;
      if(changes['shipmentModetypearray']){
        this.shipmentModetypearray = changes['shipmentModetypearray'].currentValue;
      }
      if(changes['parentTypearray']){
        this.parentTypearray = changes['parentTypearray'].currentValue;
      }
    //   if (this.Id) {
    //     this.GetTransactionList('', 0, {}, this.noOfPages, this.Id)
    //   }
    }
  }

  async initalizeForm() {
    this.tableDetails = {
      emptyDataMSg: 'No Data Found',
      data: [],
      columnDetails: [
        { columnName: 'Payment', dataFieldName: 'PaymentNumber' },
        { columnName: 'Payment Date', dataFieldName: 'PaymentDate' },
        { columnName: 'Vendor', dataFieldName: 'VendorName' },
        { columnName: 'THC No', dataFieldName: 'THCNo' },
        { columnName: 'Account', dataFieldName: 'Account', divType: '' },
        { columnName: 'Mode', dataFieldName: 'PaymentMode' },
        { columnName: 'Paid Amount', dataFieldName: 'PaidAmount', divType: '' },
        { columnName: 'Status', dataFieldName: 'paymentStatus', divType: 'status' },
      ],
      isColumnNameShow: true,

    }
  }

  getChangedValue(value, data) {
    if (data.dataField == 'FromDate') {
      if (value != null) {
        this.data[this.FromDate.dataField] = value;
      }
    }
    if (data.dataField == 'ToDate') {
      if (value != null) {
        this.data[this.ToDate.dataField] = value;
      }
    }
  }

  GetTransactionList(
    searchValue = this.searchValue,
    pageNo: number = 0,
    filterObject: any = this.filterObj,
    perPage: any = this.noOfPages,
    Id,
    CompanyId

  ) {
    Helpers.setLoading(true);
    
    if( CompanyId !== undefined && CompanyId !== null){
      this.CompanyId = CompanyId;
    }

    this.payload.Start = pageNo * perPage;
    this.payload.Length = perPage;
    
    this.payload.CompanyId = (CompanyId !== undefined && CompanyId !== null) ? CompanyId : this.CompanyId;
    
    this.payload.SearchValue = searchValue || null;
    this.payload.BillId =  null;

    if(this.parentTypearray.includes('transporter') || this.parentTypearray.includes('transporter') || this.shipmentModetypearray.includes('road freight') )
    {
      this.payload.NewVendorId = Id ? Id : this.Id;
    }
    else {
      this.payload.NewVendorId = null;
    }

    this.payload.tripId =  null;
    this.payload.AccountNo =  null;
    this.payload.Financialyear =  null;
    this.payload.FromDate = this.data.FromDate || null;
    this.payload.ToDate = this.data.ToDate || null;
    this.payload.Status = null;

    if(this.referenceType =='Driver' )
    {
      this.payload.DriverId = Id ? Id : this.Id;
    }
    else {
      this.payload.DriverId = null;
    }

    this.payload.tabId = Id ? Id : this.Id;
    this.payload.tabreferenceType = this.referenceType;


    // if(this.referenceType =='Vehicles' )
    // {
    //   this.payload.VehicleNo = Id ? Id : this.Id;
    // }
    // else {
    //   this.payload.VehicleNo = null;
    // }

    this._appService.Post("BillPayment", "GetPaymentMadeList", this.payload).subscribe((response) => {
          if (response.length) {
              this.totalCount = response[0].recordcount;
              // this.EwayBillDocURL = response[0].EwayBillDocURL;
              // this.isListApiCalled = true;
          }
          this.assignTableFields(pageNo, perPage, response);
          // this.selectedProductData = { totalQty: 0, totalWeight: 0 };
          Helpers.setLoading(false);
    },
      (err) => {
        Helpers.setLoading(false);
        this.toastr.error("Error while fetching data", err);
      }
    );
  }

  assignTableFields(pageNo, perPage, data) {
    this.tableDetails = {
      ...this.tableDetails, paginationDetails: {
        totalItems: this.totalCount,
        itemsPerPage: perPage,
        currentPage: pageNo + 1
      },
      data: data,
    }
  }

  onPageChange(pageNo: number) {
    this.GetTransactionList('', pageNo - 1, {}, this.noOfPages, this.Id , this.CompanyId);
  }

  onPageNumberChange(noOfPages: any) {
    this.noOfPages = noOfPages;
    this.GetTransactionList("", 0, {}, noOfPages, this.Id ,  this.CompanyId );
  }

  GetTransactionListDownload(
    searchValue = this.searchValue,
    pageNo: number = 0,
    filterObject: any = this.filterObj,
    perPage: any = this.noOfPages,
    Id
  ) {
    // Helpers.setLoading(true);
    console.log("download function is called!");
    // this.payload.Start = pageNo * perPage;
    // this.payload.PerPage = perPage;
    // this.payload.SearchValue = searchValue || null;
    // this.payload.userId = this.userId;
    // this.payload.CompanyId = this.CompanyId;
    // this.payload.CustomerName =  null;
    // this.payload.ShipTo =  null;
    // this.payload.FromDate = this.data.FromDate || null;
    // this.payload.ToDate = this.data.ToDate || null;
    // this.payload.Status =  'All';

    // this._appService.Post("Order_LTL", "ol_orderLTLGetListDownload", this.payload).subscribe((response) => {
    //   this.DownloadFile(response);
    //   Helpers.setLoading(false);
    // },
    //   (error) => {
    //     Helpers.setLoading(false);
    //     this.toastr.error("Error while downloading", error);
    //   }
    // );
  }

  DownloadFile(FileContent) {
    var byteNumbers = new Array(FileContent.Content.length);
    for (var i = 0; i < FileContent.Content.length; i++) {
      byteNumbers[i] = FileContent.Content.charCodeAt(i);
    }
    var blob = this.commonService.b64toBlob(FileContent.Content, FileContent.ContentType);
    let url = window.URL.createObjectURL(blob);
    $("#DownLoadFileTyreReport").attr('href', url);
    $("#DownLoadFileTyreReport").attr('download', FileContent.FileName);
    let element: HTMLElement = document.getElementById("DownLoadFileTyreReport") as HTMLElement;
    element.attributes
    element.click();
  }

}
